import CustomerAPI from 'config/api/CustomerAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';
// FFL Review
export const getFFLReviewListing = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.fflReviewListing.url,
    CustomerAPI.fflReviewListing.method,
    data
  );
  return response;
};
export const addFFLReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.addFFLReview.url,
    CustomerAPI.addFFLReview.method,
    data
  );
  return response;
};
export const fflReviewDetail = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.fflReviewDetail.url,
    CustomerAPI.fflReviewDetail.method,
    data
  );
  return response;
};
export const likeUnlikeFFLReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.likeUnlikeFFLReview.url,
    CustomerAPI.likeUnlikeFFLReview.method,
    data
  );
  return response;
};
// Product Review
export const getProductReviewListing = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.productReviewListing.url,
    CustomerAPI.productReviewListing.method,
    data
  );
  return response;
};
export const addProductReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.addProductReview.url,
    CustomerAPI.addProductReview.method,
    data
  );
  return response;
};
export const productReviewDetail = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.productReviewDetail.url,
    CustomerAPI.productReviewDetail.method,
    data
  );
  return response;
};
export const likeUnlikeProductReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.likeUnlikeProductReview.url,
    CustomerAPI.likeUnlikeProductReview.method,
    data
  );
  return response;
};
// Marketplace Review
export const getMarketplaceReviewListing = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.marketplaceReviewListing.url,
    CustomerAPI.marketplaceReviewListing.method,
    data
  );
  return response;
};
export const addMarketplaceReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.addMarketplaceReview.url,
    CustomerAPI.addMarketplaceReview.method,
    data
  );
  return response;
};
export const marketplaceReviewDetail = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.marketplaceReviewDetail.url,
    CustomerAPI.marketplaceReviewDetail.method,
    data
  );
  return response;
};
export const likeUnlikeMarketplaceReview = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.likeUnlikeMarketplaceReview.url,
    CustomerAPI.likeUnlikeMarketplaceReview.method,
    data
  );
  return response;
};
// Customer profile > to review
export const getToReviewListing = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.toReviewListing.url,
    CustomerAPI.toReviewListing.method,
    data
  );
  return response;
};
// Customer profile > replies (ffl + product + marketplace, replied only)
export const getReviewRepliesListing = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.reviewRepliesListing.url,
    CustomerAPI.reviewRepliesListing.method,
    data
  );
  return response;
};
// Customer profile > reviews summary
export const getCustomerReviewCounter = async () => {
  const response = await manageAPICall(
    CustomerAPI.customerReviewCounter.url,
    CustomerAPI.customerReviewCounter.method,
    {}
  );
  return response;
};
